import React from 'react';
import { grey } from '@mui/material/colors';
import { Button, Stack } from '@mui/material';
import { AddCircle } from '@mui/icons-material';

import { InvoiceListingActions } from '../types';

export const invoiceListingDefaultActionPanel = ({ onAddCharge, onAddEquipment }: InvoiceListingActions) => (
  <Stack direction="row" gap="1rem" sx={{ paddingBottom: '0.5rem', borderBottom: `1px solid ${grey[300]}` }}>
    <Button onClick={onAddCharge} startIcon={<AddCircle />} size="small">
      Add Invoice Item
    </Button>

    <Button onClick={onAddEquipment} startIcon={<AddCircle />} size="small">
      Add equipment
    </Button>
  </Stack>
);
